import React from 'react';
import { Container, Box, Typography, Grid } from '@mui/material';
import Hero from '../components/Hero';
import ServiceCard from '../components/ServiceCard';
import services from '../content_stub/services_content.js';
import { SEO } from '../utils/seo';
import meta from '../seo/keywords';
import HeroServicesImg from '../assets/images/hero-services.jpg';

export default function Services() {
  const m = meta.services;
  return (
    <Box>
      <SEO title={m.title} description={m.description} canonical={m.canonical} />
      <Hero title="HVAC Services for Homes & Businesses" subtitle="From AC repair to energy audits—expert help across Bloomington IN and nearby areas." bgImage=
      {HeroServicesImg} />
      <Container maxWidth="lg" sx={{ py: 6 }}>
        <Typography variant="body1" color="text.secondary" paragraph>
          Whether it’s furnace installation in Bloomington, duct cleaning in Ellettsville, or emergency HVAC in Bedford, we’re ready.
          Explore our service catalog and book a visit that fits your schedule.
        </Typography>
        <Grid container spacing={3}>
          {services.map(s => (
            <Grid item xs={12} md={3} key={s.slug}>
              <ServiceCard service={s} />
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
}
